import { useTranslation } from 'react-i18next';
import { useMutation } from 'react-query';

import { useCustomToast } from 'hooks';

import { confirmAnonymousRenter } from '../api';

export const useMutationActivateRenter = () => {
  const { t } = useTranslation();

  const { successToast, errorToast } = useCustomToast();

  return useMutation(confirmAnonymousRenter, {
    onSuccess: () => successToast(t('Rentistic is successfully activated!')),
    onError: () => errorToast(),
  });
};
